// React
import { useEffect, useState } from "react"

// Types
import type { SelectOptionType, SuccessFetch } from "../../../../../../types"

// Utils
import { useApi } from "../../../../../../utils"

export function useType() {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    api.get("/typetax/").then((res: SuccessFetch<{
      payload: {
        type_tax_id: number
        type_tax_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.type_tax_name,
          value: item.type_tax_id.toString()
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
  
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}